module.exports = __webpack_public_path__ + "img/campaign-section.57019ea3.svg";